import classNames from 'classnames'
import { Fragment, memo } from 'react'

import BasicInfo from './BasicInfo'
import UserList from './UserList'
import UserRating from './UserRating'
import useTranslations from '../../../hooks/useTranslations'
import ANTDModal from '../../../shared/antd/ANTDModal'
import { childUsers } from '../../../utils/constant'
import { entries, include, ternary } from '../../../utils/javascript'
import EquipmentTable from '../../common/presentation/EquipmentTable'
import viewUser from '../container/viewUser.container'

const ViewUser = ({ open, userDetails, hasAction, handleCancel }) => {
  const {
    parentData,
    otherDetail,
    userListView,
    basicInfoData,
    parentInfoData,
    loginUserRoleId,
    equipmentData,
    getEmailList,
    getEquipmentList,
    handleTableChange,
  } = viewUser({
    userDetails,
  })

  const { t } = useTranslations()
  const isChildUser = childUsers.includes(userDetails?.roleId)

  const viewDetails = () => {
    return (
      <div className="view-user-modal">
        <h2
          className={classNames('content-title', { 'title-text': hasAction })}
        >
          {t('user_BasicInformation')}
        </h2>
        <BasicInfo
          {...{
            basicInfoData,
            userDetails,
            getEmailList,
            ...(!isChildUser && { otherDetail }),
          }}
        />
        {isChildUser && (
          <>
            <h2
              className={classNames('content-title', {
                'title-text': hasAction,
              })}
            >
              {t('user_ParentInformation')}
            </h2>
            <BasicInfo
              {...{
                basicInfoData: parentInfoData,
                otherDetail,
                userDetails: parentData,
                getEmailList,
              }}
            />
          </>
        )}

        <UserRating />

        {!isChildUser &&
          userListView &&
          entries(userListView).map(([key, value]) => {
            return (
              <Fragment key={key}>
                <h2 className="content-title">{t(key)}</h2>
                {value.map((v, i) => {
                  const showAdd =
                    v?.isBuilding || include(v?.addAssociate, loginUserRoleId)
                  const payload = {
                    ...v?.payload,
                    userId: ternary(
                      v?.needParent,
                      userDetails?.adminId,
                      userDetails?.id,
                    ),
                  }
                  return (
                    <Fragment key={i}>
                      <UserList
                        key={i}
                        payload={payload}
                        showAdd={showAdd}
                        subTitle={v?.subTitle}
                        isBuilding={v?.isBuilding}
                        userDetails={userDetails}
                        className="mb-15"
                      />
                    </Fragment>
                  )
                })}
              </Fragment>
            )
          })}
        {!userDetails?.roleId && (
          <>
            <h2 className="content-title mb-10">{t('txt_Equipment')}</h2>
            <EquipmentTable
              showAdd={true}
              data={equipmentData}
              buildingId={userDetails?.id}
              onAddSuccess={() => getEquipmentList({})}
              handleTableChange={handleTableChange}
            />
          </>
        )}
      </div>
    )
  }

  return (
    <div>
      {open ? (
        <ANTDModal
          title={t('txt_Details')}
          centered
          open={open}
          onCancel={handleCancel}
          footer={false}
          width={1000}
        >
          {viewDetails()}
        </ANTDModal>
      ) : (
        viewDetails()
      )}
    </div>
  )
}

export default memo(ViewUser)
